import {
    AdminCapabilityEnum,
    AdminSectionEnum,
} from '@routellers/types/dist/admin/admin-permissions';
import { Center, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../providers/auth-context';
import { adminCan, SECTION_PATH } from '../utils/admin-permissions';

type Props = {
    section: AdminSectionEnum;
    capability?: AdminCapabilityEnum;
    children: React.ReactNode;
};

export const RequirePermission = ({
    section,
    capability = AdminCapabilityEnum.VIEW,
    children,
}: Props) => {
    const { t } = useTranslation();
    const { admin } = useAuth();

    if (!adminCan(admin, section, capability)) {
        const fallback = Object.values(AdminSectionEnum).find((s) =>
            adminCan(admin, s, AdminCapabilityEnum.VIEW),
        );

        if (fallback && fallback !== section) {
            return <Navigate to={SECTION_PATH[fallback]} replace />;
        }

        return (
            <Center h='50vh'>
                <Stack gap={4} ta='center'>
                    <Text fw={600}>{t('layout.noAccess')}</Text>
                    <Text size='sm' c='dimmed'>
                        {t('layout.noPermission')}
                    </Text>
                </Stack>
            </Center>
        );
    }

    return <>{children}</>;
};
